'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LatestStories = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = require('../utils/index');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _MoreFull = require('../components/MoreFull');

var _MoreFull2 = _interopRequireDefault(_MoreFull);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dateformat = require('dateformat');

var _dateformat2 = _interopRequireDefault(_dateformat);

var _entities = require('entities');

var _entities2 = _interopRequireDefault(_entities);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _sanitizeHtml = require('sanitize-html');

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

var _truncate = require('truncate');

var _truncate2 = _interopRequireDefault(_truncate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (process.env.BROWSER) {
  require('./LatestStories.css');
}

var LatestStories = function (_Component) {
  _inherits(LatestStories, _Component);

  function LatestStories(props, context) {
    _classCallCheck(this, LatestStories);

    var _this = _possibleConstructorReturn(this, (LatestStories.__proto__ || Object.getPrototypeOf(LatestStories)).call(this, props, context));

    _this._handleClick = _this._handleClick.bind(_this);
    return _this;
  }

  _createClass(LatestStories, [{
    key: '_handleClick',
    value: function _handleClick() {
      _reactGa2.default.event({
        category: this.props.pathName,
        action: 'click',
        label: 'latestStories'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var articles = _props.articles;
      var hasMore = _props.hasMore;
      var loadMore = _props.loadMore;

      var sortedArticles = _lodash2.default.sortBy(articles, function (o) {
        return new Date(o.publishedDate);
      }).reverse();

      return _react2.default.createElement(
        'section',
        { id: 'latestStories' },
        _react2.default.createElement(
          'div',
          { className: 'section-title' },
          _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement('div', { className: 'colorBlock' }),
            '最新新聞 Latest Stories'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'post-block' },
          _react2.default.createElement(
            'div',
            { className: 'latestStories-container' },
            _lodash2.default.map(_lodash2.default.take(sortedArticles, 3), function (a) {
              var image = (0, _index.imageComposer)(a).mobileImage;
              var linkStyle = _lodash2.default.get(a, 'style', '') == 'projects' ? '/projects/' : '/story/';
              var brief = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['brief', 'html'], ''), { allowedTags: [] });
              var content = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['content', 'html'], ''), { allowedTags: [] });
              var briefContent = brief.length > 0 ? brief : content;
              var writers = '文｜' + _lodash2.default.pluck(a.writers, 'name').join('、') + '｜';
              if (_lodash2.default.has(a, '_highlightResult')) {
                brief = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['_highlightResult', 'brief', 'value'], ''), { allowedTags: ['em'] });
                content = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['_highlightResult', 'content', ' value'], ''), { allowedTags: ['em'] });
                briefContent = brief.length > 0 ? brief : content;
              }
              return _react2.default.createElement(
                'div',
                { key: a.id || a._id },
                _react2.default.createElement('div', { className: 'latestStories-divider' }),
                _react2.default.createElement(
                  'div',
                  { className: 'latestStories-story' },
                  _react2.default.createElement(
                    'a',
                    { href: linkStyle + a.slug + '/', onClick: _this2._handleClick },
                    _react2.default.createElement('div', { className: 'latestStories-story__img', style: { background: 'url(' + image + ') no-repeat center center', backgroundSize: 'cover' } })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'latestStories-story__content' },
                    _react2.default.createElement(
                      'div',
                      { className: 'latestStories-story__title' },
                      _react2.default.createElement(
                        'a',
                        { href: linkStyle + a.slug + '/', onClick: _this2._handleClick },
                        _react2.default.createElement(
                          'h2',
                          null,
                          a.title
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'latestStories-story__meta' },
                      _react2.default.createElement(
                        'div',
                        { className: 'latestStories-story__author' },
                        _lodash2.default.get(a, ['writers', 'length'], 0) > 0 ? writers + ' ' : null
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'latestStories-story__date' },
                        (0, _dateformat2.default)(a.publishedDate, 'yyyy.mm.dd')
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'latestStories-story__brief' },
                      (0, _truncate2.default)(_entities2.default.decodeHTML(briefContent), 70)
                    )
                  )
                )
              );
            }),
            _lodash2.default.map(_lodash2.default.slice(sortedArticles, 5), function (a) {
              var image = (0, _index.imageComposer)(a).mobileImage;
              var linkStyle = _lodash2.default.get(a, 'style', '') == 'projects' ? '/projects/' : '/story/';
              var brief = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['brief', 'html'], ''), { allowedTags: [] });
              var content = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['content', 'html'], ''), { allowedTags: [] });
              var briefContent = brief.length > 0 ? brief : content;
              var writers = '文｜' + _lodash2.default.pluck(a.writers, 'name').join('、') + '｜';
              if (_lodash2.default.has(a, '_highlightResult')) {
                brief = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['_highlightResult', 'brief', 'value'], ''), { allowedTags: ['em'] });
                content = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['_highlightResult', 'content', ' value'], ''), { allowedTags: ['em'] });
                briefContent = brief.length > 0 ? brief : content;
              }
              return _react2.default.createElement(
                'div',
                { key: a.id || a._id },
                _react2.default.createElement('div', { className: 'latestStories-divider' }),
                _react2.default.createElement(
                  'div',
                  { className: 'latestStories-story' },
                  _react2.default.createElement(
                    'a',
                    { href: linkStyle + a.slug + '/', onClick: _this2._handleClick },
                    _react2.default.createElement('div', { className: 'latestStories-story__img', style: { background: 'url(' + image + ') no-repeat center center', backgroundSize: 'cover' } })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'latestStories-story__content' },
                    _react2.default.createElement(
                      'div',
                      { className: 'latestStories-story__title' },
                      _react2.default.createElement(
                        'a',
                        { href: linkStyle + a.slug + '/', onClick: _this2._handleClick },
                        _react2.default.createElement(
                          'h2',
                          null,
                          a.title
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'latestStories-story__meta' },
                      _react2.default.createElement(
                        'div',
                        { className: 'latestStories-story__author' },
                        _lodash2.default.get(a, ['writers', 'length'], 0) > 0 ? writers + ' ' : null
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'latestStories-story__date' },
                        (0, _dateformat2.default)(a.publishedDate, 'yyyy.mm.dd')
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'latestStories-story__brief' },
                      (0, _truncate2.default)(_entities2.default.decodeHTML(briefContent), 70)
                    )
                  )
                )
              );
            })
          ),
          hasMore ? _react2.default.createElement(_MoreFull2.default, { loadMore: loadMore }) : null
        )
      );
    }
  }]);

  return LatestStories;
}(_react.Component);

exports.default = LatestStories;
exports.LatestStories = LatestStories;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/LatestStories.js
 ** module id = 805
 ** module chunks = 0
 **/